import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import { createModel } from '@kp/js-model';
import { Adresse } from './Adresse';

export class Benutzer extends BaseModel {
    // properties
    id: number | null = null;
    email: string | null = null;
    aktiv: boolean = false;
    rolle: string | null = null;
    letzter_login: Dayjs | null = null;
    login_versuche: number = 0;
    adresse_id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;

    // custom fields
    profilAdresse: Adresse | null = null;
    team_mitglieder: number[] | null = null;

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            profilAdresse: (data) => createModel(Adresse, data)
        };
    }

    getClassName(): string {
        return 'benutzer';
    }

    profileComplete() {
        const profile = this.profilAdresse;
        if (!profile?.typ) {
            return false;
        } else if (profile.typ === 'person') {
            return profile.nachname && profile.vorname;
        } else if (profile.typ === 'organisation') {
            return profile.organisation_name;
        }
    }
}


export class BenutzerCollection extends BaseCollection<Benutzer> {
    protected modelCls = Benutzer;

    public getModelClassName(): string {
        return 'benutzer';
    }
}
